import React from "react";
import { Switch, Route } from "react-router-dom";

import List from './List';
import Form from './Form';

const Users = () =>
    (
        <Switch>
            <Route path='/users/create' component={Form} />
            <Route path='/users/:id/edit' exact component={Form} />
            <Route path='/users' component={List} />
        </Switch>
    );

export default Users;